import httpAdmin from '@/httpCommon/axiosClient';

class StoreService {
    getList = async (params?: any) => {
        const res: any = await httpAdmin.get('store', { params });

        return res?.data;
    };
    getDetail = async (id: string | number) => {
        const res: any = await httpAdmin.get(`store/${id}`);

        return res?.data;
    };
    getFilterName = async () => {
        const res: any = await httpAdmin.get('store/filter-name');

        return res?.data;
    };
    getListRemote = async () => {
        const res: any = await httpAdmin.get('remote-monitor/stores');

        return res?.data;
    };
    getAll = async () => {
        const res: any = await httpAdmin.get('store/all');

        return res?.data;
    };
}
export default new StoreService();
